<template>
  <div>
    <el-dialog
                append-to-body
                :fullscreen="dialogFull"
                :close-on-click-modal="false"
                :destroy-on-close="true"
                :before-close="handleClose"
                :visible.sync="dialogShow"
                width="50%"
                :modal-append-to-body="false"
    >
     <template slot="title">
            <div class="avue-crud__dialog__header">
                    <span class="el-dialog__title">
                            转 办
                    </span>
                    <i class="el-icon-full-screen" style="margin-right:20px;position:relative;top:-1px"  @click="dialogFull=!dialogFull"></i>

            </div>
            <el-divider></el-divider>
    </template>
      <avue-form
        ref="complaintForm"
        :option="option"
        v-model="complaintForm"
        v-if="dialogShow && changeGroup"
        @submit="complaintFormSubmit"
        @error="complaintFormError"
      >
      
                <template slot="serviceItemId">
                    <el-select
                    disabled
                            v-model="complaintForm.serviceItemId"
                            placeholder="请选择 服务项目"
                            >
                            <el-option
                             v-for="item in serviceItemList"
                             :key="item"
                             :value="item.id"
                             :label="item.name"
                             ></el-option>
                    </el-select>
                </template>
                <template slot="serviceProviderId">
                    <el-select
                    @change="providerChange"
                            v-model="complaintForm.serviceProviderId"
                            placeholder="请选择 服务商"
                            >
                            <el-option
                             v-for="(item,index) in serviceProviderList"
                             :key="index"
                             :value="item.id"
                             :label="item.name"
                             ></el-option>
                    </el-select>
                </template>
                <template slot="handerId">
                    <el-select
                      clearable
                            v-model="complaintForm.handerId"
                            placeholder="请选择 服务人员"
                            >
                            <el-option
                             v-for="(item,index) in providerUserList"
                             :key="index"
                             :value="item.userId"
                             :label="item.realName">
                            </el-option>
                    </el-select>
                </template>
        <template slot="group">
          <div>
            <el-select
              v-if="hasGroups"
              :value="complaintForm.group"
              @change="groupChange"
              placeholder="请选择 服务班组"

            >
              <el-option
                v-for="item in groupList"
                :key="item.groupId"
                :label="item.groupName"
                :value="item.id"
              >
              </el-option>
            </el-select>
            <!-- case noneGroups -->
            <el-select v-if="!hasGroups" disabled v-model="groupName">
              <el-option :value="groupName" :label="groupName"> </el-option>
            </el-select>
          </div>
        </template>
        <template slot="remark">
          <div>
            <el-input
              type="textarea"
              :rows="3"
              maxlength="500"
              show-word-limit
              placeholder="请输入 备注"
              v-model="complaintForm.remark"
            >
            </el-input>
            <remarkModel
              :remark.sync="complaintForm.remark"
              ref="complaintFormRemarkModel"
            ></remarkModel>
          </div>
        </template>
        <template slot="menuForm">
          <el-button @click="handleClose"
          ><span class="el-icon-close"></span> 取 消</el-button
          >
        </template>
      </avue-form>
    </el-dialog>
  </div>
</template>
<script>
  import { complaintFormOption,complaintFormOption2 } from "./course-dialog-form-option";
  import {
    getRemarkList,
    getGroupUser,
    getGroupDetails,
    getGroupList,
    complaint,
        getOrderServiceProvider,getProviderUserList
  } from "@/api/gateservice/order/order-list/order-list";
  import remarkModel from "./remark-model";
import {
    getServiceItemList,
} from "@/api/gateservice/order/order";
  import {fieldDetail} from "@/api/v4ward/ordersetting/setting/selfForm"
  //转办
  export default {
    components: { remarkModel },
    data() {
      return {
        serviceProviderList:[],
        providerUserList:[],
        serviceItemList:[],
        dialogFull:false,
        transferOperatorList: [],
        complaintForm: {
          group: "",
          handerId: "",
        },
        changeGroup:true,
        dialogShow: false,
        option: complaintFormOption,
        orderId: "", //工单id
        groupList: [], //班组列表
        groupName: "",
        hasGroups: false,
        subModuleType: "",
        subModuleTypeFiexd:'',//用来对比校验是否要必传负责人
      };
    },
    watch:{
      'subModuleType'(){
         this.changeGroup = false;
          if(this.subModuleTypeFiexd == this.subModuleType){
            this.option = complaintFormOption2;

          }else{
            this.option = complaintFormOption;
          }

          this.changeGroup = true;
      }
    },
    methods: {
       //获取字段填写修饰
        async getFieldDetail(projectId,moduleType,actionType){
            console.log("执行了")
            let obj = {
                projectId:projectId,
                moduleType:moduleType,
                actionType:actionType
            }

            let fieldObj2  = this.findObject(complaintFormOption2.column,'remark')
            let fieldObj =this.findObject(complaintFormOption.column,'remark')
            let chargeManNameFieldObj2 = this.findObject(complaintFormOption2.column,'handerId')
            let chargeManNameFieldObj =this.findObject(complaintFormOption.column,'handerId')
            await fieldDetail(obj).then(res=>{
                let resField,chargeManName
                res.data.forEach(item=>{
                    if(item.fieldCode == "description"){
                        resField =item
                    }
                    if(item.fieldCode == "chargeManName"){
                        chargeManName =item
                    }
                })
            if(resField){
              if( resField.defaultMustFlag ==0){

              fieldObj.rules[0].required=false
               fieldObj2.rules[0].required=false
            }else{
                 fieldObj.rules[0].required=true
                  fieldObj2.rules[0].required=true
            }
            }

            if(chargeManName){
              if( chargeManName.defaultMustFlag ==0){

              chargeManNameFieldObj.rules[0].required=false
               chargeManNameFieldObj2.rules[0].required=false
            }else{
                 chargeManNameFieldObj.rules[0].required=true
                  chargeManNameFieldObj2.rules[0].required=true
            }
            }


            })
        },
      // 弹窗关闭前
        handleClose(done){
                let self = this;
                this.$confirm('确认关闭?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取 消',
                        type: 'warning',
                })
                .then(()=> {

                        self.dialogShow = false;

                })
                .catch(()=> {

                });
        },
      //切换班组
      groupChange(val) {

        // this.groupList.forEach((item) => {
        //   if (item.groupId == val) {
        //     this.subModuleType = item.id;
        //   }
        // });
        this.subModuleType = val
        this.complaintForm.group = val;
        let groupId = "";
        this.groupList.forEach(ele=>{
          if(ele.id == val){
            groupId = ele.groupId;
            this.complaintForm.submodelName = ele.name;
          }
        })
        console.log(val)
        this.complaintForm.handerId = "";

        const params = { groupId: groupId, orderId: this.orderId };
        getGroupUser(params).then((res) => {
          res.data.userList.forEach((ele) => {
            ele.userId = ele.id;
            ele.userName = ele.realName;
          });
          res.data.userList = this.transferUserList(res.data.userList);
          this.$refs.complaintForm.updateDic("handerId", res.data.userList);
          //
        });
      },
      // 转办提交
      complaintFormSubmit(form, done) {
        console.log('123==>',123);
        form.orderId = this.orderId;
        //A：跨班组转办时需要携带subModuleType
        if (this.subModuleType) {
          form.subModuleId = this.subModuleType;
        }
        // if(this.subModuleTypeFiexd == form.subModuleId && !form.handerId){
        //   this.$message({
        //     message: '同班组转办，必选负责人',
        //     type: 'warning'
        //   });
        //   done();
        //   return;

        // }
        //B：提交
        complaint(form)
          .then((res) => {
            if (res.msg == "操作成功") {
              this.$message({
                message: res.msg,
                type: "success",
              });
            } else {
              this.$message.error(res.msg);
            }
            this.$emit("handleClose", function () {
              console.log("关闭历程表");
            });
            this.dialogShow = false;
            done();
          })
          .catch((err) => {
            done();
          });
      },
      // 转办提交报错err
      complaintFormError(error) {
        console.log("done==>", error);
      },
      // 父组件调用 subModuleType  是子类型id
      openDialog(orderId,subModuleType,orderRow) {
         this.getFieldDetail(orderRow.projectId,orderRow.moduleType,4)
        this.complaintForm = {
          group: "",
          handerId: "",
        }
        console.log(this.orderRow);
        this.complaintForm = orderRow;
        this.subModuleType = subModuleType;
        this.subModuleTypeFiexd = subModuleType;
        console.log(this.subModuleType)
        this.orderId = orderId;
        this.dialogShow = true;
        this.form = {};
        this.form.cooperateList = [];
        this.complaintForm.handerId = '';
        this.providerChange(orderRow.serviceProviderId)
        this.loadGroupList();
        this.loadRemarkList();
      },
      closeComplaintDialog() {
        this.dialogShow = false;
      },
      //获取备注模板
      loadRemarkList() {
        const params = {
          orderId: this.orderId,
          actionType: 4, //转办固定为4
        };
        // getRemarkList(params).then((res) => {
        //   console.log("res getRemarkList==>", res);
        //   this.$refs.complaintFormRemarkModel.setRemarkList(res.data);
        // });
      },
      //服务人员信息拼接
      transferUserList(list) {
        let arrList = list;
        arrList.forEach((ele, index) => {
          arrList[index].realName_ =
            ele.realName +
            (ele.phone ? "(" + ele.phone + ")" : "(无手机号)") +
            "       " +
            "      " +
            "      " +
            ele.workingCondition +
            " " +
            " " +
            " " +
            ele.currentCount;
        });
        this.transferOperatorList = arrList;
        return arrList;
      },
        providerChange(val){
          console.log('providerChange==============>',val);
            getProviderUserList({providerId:val,status:1}).then(res=>{
              setTimeout(()=>{
                this.providerUserList = res.data;
              })
            })
        },
      //获取班组列表
      loadGroupList() {
        const params = { orderId: this.orderId };
        getOrderServiceProvider({orderId:this.orderId}).then(res=>{
                this.serviceProviderList = res.data;
            })
            
            getServiceItemList({
                projectId:this.complaintForm.projectId,
                moduleType:this.complaintForm.moduleType,
                status:1
            }).then(res=>{
                this.serviceItemList = res.data;
            })
            // this.providerChange(this.complaintForm.providerId);
        // getGroupList(params).then((res) => {
        //   //A:查到多个班组,通过班组切换获取转办人列表
        //   if (res.data.length) {
        //     this.hasGroups = true;
        //     this.groupList = res.data;
        //     this.groupList.forEach(ele=>{
        //       if(ele.id == this.subModuleType){
        //         this.complaintForm.submodelName = ele.name;
        //         // this.complaintForm.group = ele.groupId
        //       }
        //     })
        //     //请求这个接口是为了回显 默认班组（当前的工单班组）,获取默认班组的成员
        //     getGroupDetails({ orderId: this.orderId }).then((res) => {
        //       this.complaintForm.group = res.data.name;
        //       res.data.userList = this.transferUserList(res.data.userList);
        //       this.$refs.complaintForm.updateDic("handerId", res.data.userList);
        //     });
        //   // B:没查到班组列表(直接通过工单id获取转办人列表)
        //   } else {
        //     this.hasGroups = false;
        //     getGroupDetails({ orderId: this.orderId }).then((res) => {
        //       res.data.userList = this.transferUserList(res.data.userList);
        //       this.groupName = res.data.name;//回显数据
        //       this.$refs.complaintForm.updateDic("handerId", res.data.userList);
        //     });
        //   }
        // });
      },
    },
  };
</script>
